import { useState } from 'react';

export default function useModal(initialState = false) {
    const [modalIsOpen, setIsOpen] = useState(initialState);

    const openModal = () => setIsOpen(true);

    return { modalIsOpen, setIsOpen, openModal };
}
